import { DefaultButton, PrimaryButton } from '@fluentui/react';
import React,{useContext, useEffect, useState} from 'react';
import "./peerreview.css";
import themeContext from '../../../../../context/theme/ThemeContext';

const ConfirmationModalFooter = (props) => {
    const { getThemeColor } = useContext(themeContext);
    const isViewer = false;
    const [showContinueButton, setShowContinueButton] = useState(false);

    useEffect(() =>{
        let timeOut = null;
        if(!showContinueButton){
            timeOut = setTimeout(() => {
                 setShowContinueButton(true);
            }, 1000); 
        }

        return () => clearTimeout(timeOut);
    },[])

  return (
    <>
        <div className='peer-modal-footer-container' style={{background: !isViewer ? getThemeColor("modal-header-footer") : "#222"}}>
            <div className='peer-modal-footer-buttons'>
                {props.SecondaryButtonList && props.SecondaryButtonList.map((obj, index)=>
                    <DefaultButton 
                    key={index}
                    text={obj.title}
                    style={{
                        marginLeft:"8px"
                    }}
                    disabled={(obj.disabled != null && obj.disabled != undefined ? obj.disabled: false)} 
                    onClick={obj.onclick}/>
                )}
            </div>
            <div className="peer-modal-footer-buttons">
                {props.DefaultButtonList && props.DefaultButtonList.map((obj,index)=>
                    <DefaultButton
                    key={index}
                    text={obj.title}
                    style={{
                        marginRight:"8px"
                    }}
                    disabled={(obj.disabled != null && obj.disabled != undefined ? obj.disabled: false)} 
                    onClick={obj.onclick}
                    />
                )}
                {props.PrimaryButtonList && props.PrimaryButtonList.map((obj,index)=>
                    <PrimaryButton
                    key={index}
                    text={obj.title}
                    style={{
                        marginRight:"8px",
                    }}
                    disabled={(obj.disabled != null && obj.disabled != undefined ? obj.disabled: false) || !showContinueButton }  
                    onClick={obj.onclick}
                    />
                )}
            </div>
        </div>
    </>
  )
}

export default ConfirmationModalFooter